// Mock data for C Doc Clinical Research Associates LLC

export const companyInfo = {
  name: "C Doc Clinical Research Associates",
  fullName: "C Doc Clinical Research Associates LLC",
  tagline: "Path To Innovative Medicine",
  description: "C Doc Clinical Research Associates is a leading Integrated Research Organization (IRO) committed to delivering innovative and high-quality clinical trials for the pharmaceutical industry and contract research organizations (CROs).",
  logo: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/6kcjl878_logo.png",
  socialLinks: {
    facebook: "https://www.facebook.com/",
    linkedin: "https://www.linkedin.com/",
    instagram: "https://www.instagram.com/"
  },
  contact: {
    email: "cdoc.clinicalresearch@gmail.com",
    phone: "845-202-0007",
    address: "7 Pine Woods Rd, Hyde Park, NY 12538"
  }
};

export const heroContent = {
  title: "Path To Innovative Medicine",
  subtitle: "C Doc Clinical Research Associates is a leading Integrated Research Organization (IRO) committed to delivering innovative and high-quality clinical trials for the pharmaceutical industry and contract research organizations (CROs).",
  cta: "Contact Us",
  heroImage: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/pcz409vt_cli.jpg"
};

export const images = {
  clinical: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/pcz409vt_cli.jpg",
  clinicalTrials: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/50to4p1p_clinical-trials.jpg",
  logo: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/6kcjl878_logo.png",
  medical: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/50to4p1p_clinical-trials.jpg",
  science: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/xtk6dm83_sfc.jpeg",
  building: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/qzzrpedr_7%20PINESS.jpg"
};

export const sponsors = {
  main: {
    name: "Bioluminux Clinical Research",
    website: "https://bioluminux.com/sponsors",
    description: "An emerging Integrated Research Organization (IRO) with dedicated research sites helping Pharma companies across the globe."
  },
  featured: {
    name: "C DOC MEDICAL GROUP PLLC",
    website: "https://www.cdoctele.com",
    logo: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/6kcjl878_logo.png",
    description: "Professional healthcare excellence - Where accessibility meets compassion."
  },
  affiliates: [
    { name: "Pfizer", logo: "https://bioluminux.com/public/assets/images/Pfizer_Logo.png" },
    { name: "Metsera", logo: "https://bioluminux.com/public/assets/images/metsera_logo.png" },
    { name: "Syneos Health", logo: "https://bioluminux.com/public/assets/images/Syneos_Health_logo.png" },
    { name: "UpStream Bio", logo: "https://bioluminux.com/public/assets/images/upstreambio_Logo.png" },
    { name: "Worldwide Clinical Trials", logo: "https://bioluminux.com/public/assets/images/worldwide_logo.png" },
    { name: "Vertex Pharmaceuticals", logo: "https://bioluminux.com/public/assets/images/vertex_logo.png" }
  ],
  therapeuticAreas: [
    "Vaccines", "Metabolic and Endocrinology", "Respiratory", "Skin Cancer",
    "Women's Health", "CNS/Psychiatry", "Gastroenterology", "Cardiology",
    "Dermatology", "Hematology", "Immunology", "Rheumatology", "ENT", "Musculoskeletal"
  ]
};

export const providers = [
  {
    id: 1,
    name: "Christina M. Antoine, MD, MBA, MHSA, RRT",
    title: "Medical Director & Principal Investigator",
    specialty: "Internal Medicine",
    image: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/697f5b3037a33e1b86c45e7d/6172b30f5_antoine-christina-1053734863.jpg",
    description: "Board-certified internal medicine physician with extensive experience in providing comprehensive care to adults and older adults. Dr. Antoine is committed to patient-centered healthcare and building long-term relationships with her patients.",
    education: "MD, Medical School",
    certifications: ["Board Certified - Internal Medicine", "Clinical Research Certification"],
    languages: ["English"],
    location: "Poughkeepsie, NY",
    role: "leadership"
  }
];

export const leadership = [
  {
    id: 1,
    name: "Christina M. Antoine, MD, MBA, MHSA, RRT",
    title: "Founder & Medical Director",
    image: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/697f5b3037a33e1b86c45e7d/6172b30f5_antoine-christina-1053734863.jpg",
    bio: "Dr. Christina M. Antoine is the founder and Medical Director of C Doc Clinical Research Associates LLC. A board-certified internal medicine physician.",
    credentials: [
      "Board Certified Internal Medicine Physician",
      "Principal Investigator",
      "Over 15 years of clinical experience"
    ]
  }
];

export const aboutContent = {
  title: "Path to Innovative Medicine",
  paragraphs: [
    "Our expert research teams provide reliable and efficient services worldwide, driving the transformation of scientific discoveries into groundbreaking patient treatments while ensuring the utmost safety of trial participants.",
    "We recognize the invaluable contributions of clinical trial participants and are dedicated to upholding the highest standards of care throughout the research process."
  ],
  mission: "To advance medical science through rigorous clinical research while ensuring the highest standards of participant care and safety.",
  vision: "To be a leading clinical research organization in New York State, known for excellence in patient care, innovative research, and medical advancement."
};

export const servicesCards = [
  {
    id: 1,
    title: "Clinical Trial Participation",
    description: "Patient care is at the heart of everything we do, and we are committed to ensuring you are treated with the utmost care and respect whilst maintaining the highest standard of research. We will help shape the future of world health for you and future generations.",
    image: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/50to4p1p_clinical-trials.jpg",
    link: "/participants",
    linkText: "Participants"
  }
];

export const commitmentCards = [
  {
    id: 1,
    title: "Community Engagement",
    description: "We engage with local communities to raise awareness about clinical trials, healthcare innovations, and the importance of medical research. Our outreach programs are designed to educate individuals on the significance of clinical research, empowering them with knowledge about health advancements and the vital role they play in improving medical outcomes.",
    image: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/pcz409vt_cli.jpg",
    link: "#",
    linkText: "Learn More"
  },
  {
    id: 2,
    title: "Professional Training Programs",
    description: "C Doc Clinical Research Associates offers comprehensive training programs for medical professionals interested in pharmaceutical medicine and clinical research. Our programs are designed to equip physicians with specialist knowledge and capabilities to practice in the development and maintenance of medicines.",
    image: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/50to4p1p_clinical-trials.jpg",
    link: "#",
    linkText: "Learn More"
  },
  {
    id: 3,
    title: "Apprenticeship Programs",
    description: "Our apprenticeship programs provide hands-on experience and expert mentorship for both experienced and aspiring professionals in clinical research. These programs are designed to help participants develop valuable skills and gain practical knowledge in the medical research field.",
    image: "https://customer-assets.emergentagent.com/job_research-portal-38/artifacts/xtk6dm83_sfc.jpeg",
    link: "#",
    linkText: "Register Interest"
  }
];

export const ctaContent = {
  title: "Interested in Participating in a Study?",
  description: "Volunteer for medical research to learn more about your condition, gain access to new treatments and medications, and contribute to medical advancements.",
  buttonText: "Join a Study",
  link: "/join-study"
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Our Providers", path: "/providers" },
  { name: "For Participants", path: "/participants" },
  { name: "Join a Study", path: "/join-study" },
  { name: "Contact Us", path: "/contact" }
];

export const stats = [
  { label: "Clinical Trials", value: "50+" },
  { label: "Patients Served", value: "1000+" },
  { label: "Years Experience", value: "15+" },
  { label: "Research Partners", value: "25+" }
];
